import React, {
    useEffect,
    useState,
    useContext,
    useCallback,
    useRef,
} from "react";
import { Button, TextField } from "@mui/material";
import GlobalContext from "../contexts/globalcontext";
import { Send } from "@mui/icons-material";
import { getTickerByCrypto, getOpenOrders } from "../api/apiCalls";
import Ticker from "../components/ticker";
import { Box } from "@mui/system";

const Tickers = () => {
    const { setTotalOrders, sbAlert } = useContext(GlobalContext);
    const num = useRef(-1);
    const dataRef = useRef([]);
    const timeout = useRef(0); //Depends how many minutes
    const [searchArray, setsearchArray] = useState(
        JSON.parse(localStorage.getItem("search")) || []
    );
    const [data, setData] = useState([]);

    const retrieveTotalOrders = useCallback(async (msg = false) => {
        const data = await getOpenOrders();
        setTotalOrders(data.length);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let cPair = document.getElementById("cryptoPair").value.toUpperCase();
        const cImg = cPair.split("_")[0].toLowerCase();
        console.log("Form Submitted: ", cPair, "/", cImg);
        num.current = -1;
        //Check existing array does not have this pair
        const checkArray = searchArray.find((item) => item.name === cPair);
        if (checkArray) {
            sbAlert("Crypto Pair already streaming", "info");
        } else {
            // Check CDC got this pair or not
            const res = await getData(cPair);
            // console.log(res);
            if (res.name) {
                setsearchArray([...searchArray, { name: cPair, imgscr: cImg }]);
                sbAlert("Added to Alert", "success");
            } else {
                sbAlert("Crypto pair does not exist!", "error");
            }
        }
    };

    const saveSearchArrayLocalStorage = useCallback(() => {
        localStorage.setItem("search", JSON.stringify(searchArray));
    }, [searchArray]);

    const handleRemoveSearchItem = (name) => {
        let newSearchArray = searchArray.filter((item) => item.name !== name);
        num.current = -1;
        setsearchArray(newSearchArray);
        sbAlert(`${name} removed from stream`, "success");
    };

    const getData = async (cryptopair) => {
        const res = await getTickerByCrypto(cryptopair);
        //console.log(res);
        //console.log(res[0].i);
        if (res?.length > 0) {
            return {
                name: res[0].i,
                price: res[0].a,
                high: res[0].h,
                low: res[0].l,
            };
        }
        return {};
    };

    const handleGetCrypto = useCallback(async () => {
        let newArr = [];
        //Get Total Orders
        if (timeout.current <= 0) {
            // console.log("timeout lu");
            retrieveTotalOrders();
            timeout.current = 1 * 60000; // in minutes
        } else timeout.current -= 1500;

        // console.log("timeout value", timeout.current);
        // console.log("num.current", num.current);
        // console.log("searchArray.length", searchArray.length);
        if (num.current > searchArray.length) {
            console.log("Reload All....");
            num.current = -1;
        }

        if (num.current < 0) {
            for (let i = 0; i < searchArray.length; i++) {
                let nRes = await getData(searchArray[i].name);
                if (nRes.length === 0) {
                    console.log("nRes1", searchArray[num.current].name);
                }
                nRes.imgscr = "/cryptoimg/" + searchArray[i].imgscr + ".jpg";
                newArr.push(nRes);
                // await new Promise((r) => setTimeout(r, 1));
            }
            if (searchArray.length > 0) num.current = 0;
            setData(newArr);
            dataRef.current = newArr;
        } else {
            // console.log("searchArray", searchArray.length);
            if (num.current === searchArray.length) num.current = 0;
            let nRes = {};
            if (searchArray[num.current]?.name) {
                nRes = await getData(searchArray[num.current].name);
                if (nRes.length === 0) {
                    console.log("nRes2", searchArray[num.current].name);
                }
                if (searchArray[num.current]?.imgscr)
                    nRes.imgscr =
                        "/cryptoimg/" +
                        searchArray[num.current].imgscr +
                        ".jpg";
            }
            if (dataRef.current.length === 0) {
                newArr.push(nRes);
            } else {
                newArr = dataRef.current.map((item) => {
                    if (nRes.name === item.name) return nRes;
                    else return item;
                });
            }
            setData(newArr);
            dataRef.current = newArr;
            num.current++;
        }
    }, [searchArray]);

    useEffect(() => {
        let timeout;
        // console.log("Tickers-UseEffect");
        handleGetCrypto();
        timeout = setInterval(() => {
            handleGetCrypto();
        }, 1500);
        return () => {
            clearInterval(timeout);
        };
    }, [handleGetCrypto, searchArray]);

    useEffect(() => {
        if (searchArray?.length) saveSearchArrayLocalStorage();
    }, [searchArray, saveSearchArrayLocalStorage]);

    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <form onSubmit={handleSubmit}>
                    <TextField
                        id="cryptoPair"
                        label="Crypto Pair"
                        variant="outlined"
                        required
                        sx={{ width: 150 }}
                        placeholder="CRO_USDT"
                        size="small"
                    />
                    <Button
                        variant="contained"
                        endIcon={<Send />}
                        style={{
                            marginTop: "1px",
                            marginLeft: "10px",
                            padding: "6px",
                            width: "100px",
                        }}
                        type="submit"
                    >
                        Add
                    </Button>
                </form>
            </Box>
            <Ticker
                data={data}
                handleRemoveSearchItem={handleRemoveSearchItem}
                timeout={timeout}
            />
        </>
    );
};

export default Tickers;
